import React from "react";
import "./index.scss";
import { discoverCardsData } from "./data/discover-cards-data";
import InfraStructureOfferings from "./infrastructure-offerings";
import { startBuildingData } from "./data/start-building";
import Banner from "./banner";
import TextNavigation from "./text-navigation";
import NavigationCard from "./navigation-card";
import ImageNavigationCard from "./image-navigation-cards";
import { Carousel, CarouselItem } from "react-bootstrap";
import { createFunctionalComponentFromView } from "../../utils/view-controller";
import useHomeController from "./controller";
import { HomePageCarousel } from "./carousel-config";

const HomePage = createFunctionalComponentFromView(useHomeController, (controller) => {
  const renderBannerSection = () => (
    <Carousel
      interval={HomePageCarousel.interval}
      indicators={HomePageCarousel.items.length > 1}
      controls={false}
    >
      {
        HomePageCarousel.items.map((bannerProps: {
          heading: string;
          description: string;
          links?: Array<{ url: string; label: string; isExternalLink?: boolean }>;
          imageSource?: string;
          color?: string;
          backgroundColor?: string;
        }, index: number) => (
          <CarouselItem key={index}>
            <Banner {...bannerProps} />
          </CarouselItem>
        ))
      }
    </Carousel>
  );

  const renderDescriptionSection = () => (
    <div className="description-section">
      NEO is our own in-house built self-service developer experience portal that unifies and streamlines all the platform capabilities to help you
      focus on the most important thing, developing apps.
    </div>
  );

  const renderApplicationSection = () => (
    <div className="section-bg-dark">
      <div className="application-section">
        <div className="navigation-cards">
          {controller.applicationSectionCardConfigs.map((cardData) => (
            <NavigationCard
              key={cardData.buttonName}
              {...cardData}
            />
          ))}
        </div>
      </div>
    </div>
  );

  const renderDiscoverCardsSection = () => (
    <div className="discover-section">
      <h1>Discover</h1>
      <div className="navigation-cards">
        {discoverCardsData.map((cardData) => (
          <ImageNavigationCard
            key={cardData.title}
            {...cardData}
          />
        ))}
      </div>
    </div>
  );

  const renderStartBuildingSection = () => (
    <div className="start-building-section">
      <h1>Start building</h1>
      <div className="navigation-links">
        {startBuildingData.map((cardData) => (
          <TextNavigation
            {...cardData}
            key={cardData.text}
          />
        ))}
      </div>
    </div>
  );

  return (
    <div className="HomePage">
      {renderBannerSection()}
      {renderDescriptionSection()}
      {renderApplicationSection()}
      {renderDiscoverCardsSection()}
      <InfraStructureOfferings />
      {renderStartBuildingSection()}
    </div>
  );
});

export default HomePage;
